'use client';

import { cn } from '@/app/lib/utils';
import { Icon } from '../Icon';
import { Typography } from '../Typography';

type PopupPosition = 'top' | 'right' | 'bottom' | 'left' | '';

interface PopupProps {
  content: string;
  position?: PopupPosition;
  className?: string;
  onClose: () => void;
  isOpen: boolean;
}

const baseWrapperClasses =
  'relative z-10 w-97.5 border border-primary bg-white transition-opacity duration-300 ease-in-out';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function PopupInformation({ content, className, onClose, isOpen, position = '' }: PopupProps) {
  return (
    <div
      className={cn(baseWrapperClasses, isOpen ? 'opacity-100 visible' : 'opacity-0 invisible', className)}
      style={{ padding: '18px 12px 18px 22px' }}
    >
      <svg
        className="absolute -left-[10px] top-[20px] hidden lg:block"
        width="10"
        height="16"
        viewBox="0 0 10 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 8L10 0V16L0 8Z" fill="#E31E24" />
        <path d="M1 8L10 1V15L1 8Z" fill="white" />
      </svg>

      <div className="flex items-start justify-between">
        <Typography variant="bodyMd" className="flex-1 max-w-81">
          {content}
        </Typography>
        <button
          type="button"
          onClick={onClose}
          className="cursor-pointer text-secondary-300 transition-colors duration-200 hover:text-secondary-400 flex-shrink-0"
        >
          <Icon name="CloseBtn" size={14} />
        </button>
      </div>
    </div>
  );
}
